import React, { useRef } from 'react'
import { useAIContext } from '../context/AIProvider'
import { Button, Grid, Flex, Typography } from 'components'
import { UilArrowLeft } from '@iconscout/react-unicons'
import { Chat } from './Chat/Chat'
import styled from 'styled-components'
import { color } from '@evrekadev/evreka-ui-components'
import { ActionType } from '../types'
import { Typewriter } from './Typewriter'
import { useTranslation } from 'utils/useTranslation'

export const ActionLayout: React.FC = () => {
  const { t } = useTranslation('pages.ai')
  const { setPage, selectedAction } = useAIContext()
  const printRef = useRef<HTMLDivElement>(null)

  return (
    <Grid
      fullHeight
      fullWidth
      columns={'3fr 2fr'}
      style={{
        maxHeight: '100%',
        overflow: 'hidden',
      }}
    >
      <DataSidebarStyled ref={printRef}>
        <Flex middle="zero" between="zero">
          <Button
            iconLeft={UilArrowLeft}
            variant="text"
            color="secondary"
            size="small"
            onClick={() => setPage(undefined)}
          >
            {t('back')}
          </Button>
          <Flex gap={0.5}>
            {/* <ReactToPrint
              content={() => printRef.current}
              trigger={() => (
                <Button iconLeft={UilDownloadAlt} variant="outline" color="secondary" size="small">
                  Download Report
                </Button>
              )}
            /> */}
          </Flex>
        </Flex>
        {selectedAction && <ActionHeader {...selectedAction} />}
        {selectedAction?.dataComponent}
      </DataSidebarStyled>
      <Chat />
    </Grid>
  )
}

const ActionHeader: React.FC<ActionType> = ({ title, description }) => {
  const { t } = useTranslation('pages.ai.starters')
  return (
    <Flex directionColumn="zero">
      <Typography fontSize="text_lg" fontWeight="semibold" color="grey900">
        <Typewriter>{t(title)}</Typewriter>
      </Typography>
      <Typography fontSize="text_sm" color="grey700">
        <Typewriter>{t(description)}</Typewriter>
      </Typography>
    </Flex>
  )
}

const DataSidebarStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-right: 1px solid ${color('grey200')};
  padding: 1rem 1.5rem;
  max-height: 100%;
  overflow: hidden;

  button {
    width: fit-content;
  }

  p {
    margin: 0;
  }
`
